export default __webpack_public_path__ + "static/media/download.15e53b39.png";